import { ViewChild, Input, ChangeDetectionStrategy, Component } from '@angular/core';
import { Details } from '@details/Interfaces/details';
import { LayoutOrientation } from '@common/enums/layout-orientation';
import { isUnTypedDetailsItem, DetailsItemTypesArray, DetailsItemType } from '@details/Interfaces/details-item-types';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'mojo-detail-items-body',
  templateUrl: './detail-items-body.component.html'
})
export class DetailItemsBodyComponent  {

  @Input() data: DetailsItemTypesArray | Details = null;
  orientation = LayoutOrientation;

  isUnTypedDetailsItem(v: DetailsItemType) {
    return isUnTypedDetailsItem(v);
  }

  cssClass(v: DetailsItemType) {
    return v['cssClass'];
  }

  isBlank(v: DetailsItemType) {
    return (v && v['kind'] === 'blank');
  }

  ngAfterViewInit() {
    
  }

  hasSections(): boolean {
    return this.data && ('sections' in this.data);
  }

  checkIfValidUrl(potentialUrl: any){
    try{
      if(new URL(potentialUrl)){
      return true;
      }
      else{
        return false;
      }
    }
    catch{
      return false;
    }
  }

  prepareLink(url: any): string {
    if (url && typeof url == 'string' && !this.checkIfValidUrl(url)) {
      return 'https://' + url;
    }
    return url;
  }
}
